import loadable from "@loadable/component";
import CreateIcon from "../../Icons/Create";
import APIS from "../../constant/EndPoint";
import { useParams } from "react-router";
import usePatchHook from "../../customHooks/usePatchHook";
import useGetHook from "../../customHooks/useGetHook";
import Spinner from "../../components/Reusable/Spinner";
import usePostHook from "../../customHooks/usePostHook";

const EditOrderComponent = loadable(
  () => import("../../components/Order/EditOrder")
);
const EditOrder = () => {
  const { id } = useParams()

  const { data: order, isLoading } = useGetHook({
    queryKey: [`order-${id}`],
    url: `${APIS.ORDER}${id}/`,
    params: {},
  });



  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["order"],
    navigateURL: "/order",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.ORDER}${id}/`;
    console.log(values)
    let formData = {
      ...values
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      console.log(res);
    } catch (err) {
      console.log(err);
    }
  };

  const { mutateAsync: createCustomerMutateAsync, isPostLoading: createCustomerLoading } = usePostHook({
    queryKey: ["customers"],
    navigateURL: "/customer",
  });

  const handleCreateCustomer = async (values: any, setError: any) => {
    const url = `${APIS.CUSTOMER}`;
    let formData = {
      ...values,
      "mobile_number": `+977${values?.mobile_number}`,
      "secondary_contact": values?.secondary_contact ? `+977${values?.secondary_contact}` : `+977${values?.mobile_number}`
    };
    try {
      await createCustomerMutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Edit Consignment</span>
      </div>
      {isLoading ? <Spinner /> :
        <EditOrderComponent
          isLoading={isPatchLoading}
          handleEdit={handleEdit}
          order={order}
          handleCreateCustomer={handleCreateCustomer}
          createCustomerLoading={createCustomerLoading}
        />
      }

    </>
  );
};
export default EditOrder;
